import { render } from "./Heading.vue?vue&type=template&id=28e92538"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"

import "./Heading.vue?vue&type=style&index=0&id=28e92538&lang=scss"
script.render = render

export default script